var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFactionFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492.771 492.771",
    style: {
      enableBackground: "new 0 0 492.771 492.771"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "XMLID_686_",
    d: "M431.732,279.197l-67.804-76.611l67.804-76.603c3.867-4.371,4.813-10.611,2.406-15.937 c-2.39-5.325-7.684-8.75-13.537-8.75h-88.16V38.121c0-8.196-6.641-14.846-14.854-14.846H108.432C107.197,10.241,96.355,0,82.993,0 S58.786,10.241,57.551,23.275h-0.239v2.406v200.18v241.228c0,14.18,11.501,25.682,25.682,25.682 c14.179,0,25.681-11.502,25.681-25.682V225.861h102.628v63.177c0,8.196,6.642,14.846,14.854,14.846h194.462 c5.838,0,11.132-3.425,13.538-8.751C436.545,289.809,435.6,283.568,431.732,279.197z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactionFlag);
export default __webpack_public_path__ + "static/media/faction-flag.ac0c3014bd525c2ba8dfc6b84d7c5789.svg";
export { ForwardRef as ReactComponent };